module.exports = __webpack_public_path__ + "img/md-square.fa10cfed.svg";